import { render } from "./ReferralListPage.vue?vue&type=template&id=3e1e8d07"
import script from "./ReferralListPage.vue?vue&type=script&lang=js"
export * from "./ReferralListPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__